import { CircleProps } from 'atomic/circle/circle.interface';
import classNames from 'classnames';
import React from 'react';

import './circle.scss';

const Circle: React.FC<CircleProps> = ({
    onClick,
    color,
    size,
    background,
    border,
    className,
    ariaLabel,
    hoverEffect = true,
    children,
    title,
    ...rest

}) => {
    const classes = classNames(
        {
            ['circle-comp']: true,
            [`circle-comp--color-${color}`]: Boolean(color),
            [`circle-comp--bg-${background}`]: Boolean(background),
            [`circle-comp--border-${border}`]: Boolean(border),
            [`circle-comp--size-${size}`]: Boolean(size),
            ['circle-comp--hover']: Boolean(hoverEffect),
            [String(className)]: Boolean(className)
        }
    );

    if (rest.tag === 'a') {
        return React.createElement(rest.tag, {
            href: rest.href,
            target: rest.target,
            rel: rest.rel,
            title,
            onClick,
            className: classes,
            ['aria-label']: ariaLabel || void 0
        }, children);
    } else {
        return React.createElement(rest.tag, {
            title,
            onClick,
            className: classes,
            ['aria-label']: ariaLabel || void 0
        }, children);
    }
};

export default Circle;
